"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("react-virtualized/dist/commonjs/Grid"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  color: ", ";\n  font-size: 11px;\n  font-weight: 600;\n  outline: none;\n  pointer-events: auto;\n  text-transform: uppercase;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var backgroundStyle = (0, _emotion.css)(_templateObject(), colors.platinum, colors.shale);

var SelectAll =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SelectAll, _PureComponent);

  function SelectAll() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectAll);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectAll)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCell", function () {
      return null;
    });
    return _this;
  }

  (0, _createClass2.default)(SelectAll, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rowHeight = _this$props.rowHeight,
          onGetFirstColumnWidth = _this$props.onGetFirstColumnWidth;
      var leftColumnWidth = onGetFirstColumnWidth();
      return _react.default.createElement(_Grid.default, {
        cellRenderer: this.renderCell,
        className: backgroundStyle,
        columnCount: 1,
        columnWidth: leftColumnWidth,
        height: rowHeight,
        rowCount: 1,
        rowHeight: rowHeight,
        tabIndex: null,
        width: leftColumnWidth
      });
    }
  }]);
  return SelectAll;
}(_react.PureComponent);

exports.default = SelectAll;
(0, _defineProperty2.default)(SelectAll, "propTypes", {
  rowHeight: _propTypes.default.number.isRequired,
  onGetFirstColumnWidth: _propTypes.default.func.isRequired
});